import { render, staticRenderFns } from "./backupComponent.vue?vue&type=template&id=5d5c99f7&scoped=true&"
import script from "./backupComponent.vue?vue&type=script&lang=js&"
export * from "./backupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c99f7",
  null
  
)

export default component.exports